export const pink = {
  900: '#640648',
  800: '#8C0864',
  700: '#A80A79',
  600: '#C00B8A',
  500: '#D50D99',
  400: '#E569BF',
  300: '#EC96D2',
  200: '#F2B7E0',
  100: '#F7D2EC',
  50: '#FBEAF6',
}
